<template>
<div class="chapter">
<div class="inner_page">
<p class="tp" id="tp"><a id="page7"></a>The Holocaust</p>
<p class="tp2">The Human Tragedy</p>
<p class="tp1">Martin Gilbert</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// tp.vue?46a1d2e8